import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, Teleport as _Teleport, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "container-wide w-100 flex-shrink-1 flex-grow-1 d-flex flex-column card bg-white p-5",
  style: {"min-height":"0"}
}
const _hoisted_2 = { class: "d-flex flex-row justify-content-between align-items-center mb-4" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-plus" }, null, -1)
const _hoisted_4 = {
  class: "flex-shrink-1 flex-grow-1",
  style: {"min-height":"0"}
}
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "flex-grow-1" }
const _hoisted_7 = { class: "m-0" }
const _hoisted_8 = { class: "flex-shrink-0" }
const _hoisted_9 = { class: "flex-shrink-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AnimatedInput = _resolveComponent("AnimatedInput")!
  const _component_translate = _resolveComponent("translate")!
  const _component_Button = _resolveComponent("Button")!
  const _component_ProgressBar = _resolveComponent("ProgressBar")!
  const _component_Tag = _resolveComponent("Tag")!
  const _component_InfiniteList = _resolveComponent("InfiniteList")!
  const _component_Breadcrumb = _resolveComponent("Breadcrumb")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_AnimatedInput, {
        modelValue: _ctx.searchTerm,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchTerm) = $event)),
        modelModifiers: { lazy: true, trim: true },
        class: "flex-grow-1 mr-3",
        type: "text",
        label: _ctx.i18n.$gettext('Formular Suchen'),
        style: {"max-width":"400px"}
      }, null, 8, ["modelValue", "label"]),
      (_ctx.rpcClient.isInternalUser)
        ? (_openBlock(), _createBlock(_component_Button, {
            key: 0,
            class: "my-1 d-block",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.router.push('/formulare/anlage#top')))
          }, {
            default: _withCtx(() => [
              _hoisted_3,
              _createTextVNode("  "),
              _createVNode(_component_translate, null, {
                default: _withCtx(() => [
                  _createTextVNode("Formular erstellen")
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_4, [
      (_ctx.projectTemplates.call?.loading)
        ? (_openBlock(), _createBlock(_component_ProgressBar, {
            key: 0,
            mode: "indeterminate"
          }))
        : (_openBlock(), _createBlock(_component_InfiniteList, {
            key: 1,
            class: "h-100 w-100",
            "get-all-items": _ctx.sort(_ctx.allTemplates.filter(t => _ctx.matchesSearchTerm(t))),
            "id-property": 'id',
            "auto-scroll-at-start": ""
          }, {
            element: _withCtx((props) => [
              _createElementVNode("div", {
                class: "card clickable d-flex flex-row align-items-center p-2 mb-2",
                style: {"margin":"0 2px"},
                onClick: ($event: any) => (_ctx.goToTemplate(props.item.value))
              }, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("p", _hoisted_7, _toDisplayString(props.item.label), 1)
                ]),
                _createElementVNode("div", _hoisted_8, [
                  (props.item.active)
                    ? (_openBlock(), _createBlock(_component_Tag, {
                        key: 0,
                        value: _ctx.i18n.$gettext('Aktiv'),
                        severity: "success",
                        class: "mr-2"
                      }, null, 8, ["value"]))
                    : (_openBlock(), _createBlock(_component_Tag, {
                        key: 1,
                        value: _ctx.i18n.$gettext('Inaktiv'),
                        class: "mr-2"
                      }, null, 8, ["value"]))
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _createVNode(_component_Button, {
                    class: "mr-2",
                    icon: "pi pi-copy",
                    onClick: _withModifiers(($event: any) => (_ctx.duplicateTemplate(props.item)), ["stop","prevent"])
                  }, null, 8, ["onClick"]),
                  (!props.item.value.startsWith('EU-'))
                    ? (_openBlock(), _createBlock(_component_Button, {
                        key: 0,
                        class: "p-button-danger",
                        icon: "pi pi-trash",
                        onClick: _withModifiers(($event: any) => (_ctx.confirmDelete(props.item.value)), ["stop","prevent"])
                      }, null, 8, ["onClick"]))
                    : _createCommentVNode("", true)
                ])
              ], 8, _hoisted_5)
            ]),
            _: 1
          }, 8, ["get-all-items"]))
    ]),
    (_openBlock(), _createBlock(_Teleport, { to: "#breadcrumbs" }, [
      _createVNode(_component_Breadcrumb, {
        home: { icon: 'pi pi-home', to: '/' },
        model: _ctx.breadcrumbs
      }, null, 8, ["model"])
    ]))
  ]))
}